import { FaEthereum } from "react-icons/fa";
import React, { useState, useEffect, useRef } from "react";
import { SiSolana } from "react-icons/si";
import { FiGlobe } from "react-icons/fi";  // 🌍 Website icon
export default function MainPage() {
  const [hovered, setHovered] = useState(null); // desktop
  const [clicked, setClicked] = useState(null); // mobile
  const [isTouch, setIsTouch] = useState(false);
  const hideTimer = useRef();

  useEffect(() => {
    setIsTouch("ontouchstart" in window || navigator.maxTouchPoints > 0);

    const handleClickOutside = (e) => {
      if (!e.target.closest(".popup-trigger")) {
        setHovered(null);
        setClicked(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  const handleMouseEnter = (icon) => {
    if (isTouch) return;
    clearTimeout(hideTimer.current);
    setHovered(icon);
  };

  const handleMouseLeave = () => {
    if (isTouch) return;
    clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setHovered(null), 500);
  };

  const handleIconClick = (icon) => {
    if (!isTouch) return;
    setClicked(clicked === icon ? null : icon);
  };

  const showPopup = (icon) => {
    return isTouch ? clicked === icon : hovered === icon;
  };

  return (
    <div
      className="relative w-full min-h-screen bg-cover bg-center overflow-hidden flex flex-col"
      style={{
        backgroundImage:
          "url('https://babyu.tech/static/media/bg.2a6b3ddbcc86954270d9.png')",
      }}
    >
      {/* Glow Effects */}
      <div className="pointer-events-none absolute top-[25%] left-[-200px] w-[500px] h-[500px] bg-[#FF82BD] opacity-40 rounded-full blur-[240px] z-0" />
      <div className="pointer-events-none absolute top-[40%] right-[-200px] w-[500px] h-[500px] bg-[#FF82BD] opacity-40 rounded-full blur-[240px] z-0" />
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-[#1E1A2E] opacity-80 rounded-full blur-[280px] z-0" />

      {/* Content */}
      <div className="relative z-20 flex flex-col justify-between p-4 sm:p-8 flex-grow">
        
        {/* Top */}
        <div className="flex flex-col items-center text-center justify-center mt-6 sm:mt-10">
          <img
            src="./Group71.png"
            alt="Baby Unicorn"
            className="w-[260px] sm:w-[350px] md:w-[450px] mb-3 sm:mb-4 -translate-x-1 sm:-translate-x-9"
          />

          <h1 className="text-white font-bold mb-3 sm:mb-4 text-3xl sm:text-4xl md:text-5xl leading-snug">
            Baby Unicorn Token – Choose Your Chain 🚀
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-white font-normal leading-relaxed mb-5 sm:mb-6 max-w-2xl">
            Welcome to the magical world of Baby Unicorn — a community-driven
            token bridging Ethereum and Solana.
          </p>

          <div className="space-y-4 sm:space-y-3 text-white text-base sm:text-lg md:text-xl leading-relaxed">
            <div>
              <h2 className="font-semibold text-pink-300 text-lg sm:text-xl md:text-2xl">
                🌐 Ethereum (ETH) – Presale Ongoing
              </h2>
              <p>Join the exclusive presale before we launch on exchanges.</p>
              <p>🔥 Limited supply, bonus rewards for early holders!</p>
            </div>
            <div>
              <h2 className="font-semibold text-blue-300 text-lg sm:text-xl md:text-2xl">
                ⚡️ Solana (SOL) – Trading Live Now
              </h2>
              <p>We’re already live on Solana!</p>
              <p>
                💎 Trade instantly on Pump.fun, Dexscreener and be part of the
                Solana unicorn army!
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Buttons */}
{/* Bottom Buttons */}
{/* Bottom Buttons */}
{/* Bottom Buttons */}
{/* Bottom Buttons */}
{/* Bottom Buttons */}
{/* Bottom Buttons */}
{/* Bottom Buttons */}
<div className="flex flex-col items-center gap-3 pb-6 sm:flex-row sm:justify-between sm:px-8 sm:pb-8 sm:mt-16 w-full">

  {/* ETH */}
  <a
    href="/"
    rel="noopener noreferrer"
    className="order-1 flex justify-center items-center gap-2 h-[60px] sm:h-[64px] rounded-full font-semibold text-white border-2 border-white 
      bg-[linear-gradient(90deg,#FF6EB3_0%,#AA81FF_47.12%,#6BC9FF_100%)] 
      shadow-[0px_4px_16px_#ff49b8] transition-transform w-full sm:w-[200px] sm:hover:scale-105 text-lg"
  >
    <FaEthereum className="text-xl sm:text-2xl sm:hover:scale-125 sm:hover:rotate-12 transition-transform" />
    <span>ETH</span>
  </a>

  {/* Solana */}
  <div
    className="order-2 sm:order-2 relative popup-trigger flex justify-center items-center gap-4 h-[60px] sm:h-[64px] rounded-full border-2 border-white 
      bg-[linear-gradient(90deg,#FF6EB3_0%,#AA81FF_47.12%,#6BC9FF_100%)] 
      shadow-[0px_4px_16px_#ff49b8] w-full sm:w-[280px]"
    onMouseEnter={() => handleMouseEnter("sol")}
    onMouseLeave={handleMouseLeave}
    onClick={() => handleIconClick("sol")}
  >
    <button className="flex justify-center items-center gap-2 px-4 h-full w-full rounded-full font-semibold text-white border-2 border-white 
      bg-[linear-gradient(90deg,#FF6EB3_0%,#AA81FF_47.12%,#6BC9FF_100%)] 
      shadow-[0px_4px_16px_#ff49b8] transition-transform sm:hover:scale-105 text-lg overflow-hidden">
      <SiSolana className="text-xl sm:text-2xl shrink-0" />
      <span className="whitespace-nowrap">SOLANA</span>
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/8490b493579621a21a9806eb89a7ed0f66e15b73?placeholderIfAbsent=true&apiKey=0c11d46dd7d64d7a84bf3e17dbee5689"
        className="object-contain w-[25px] max-md:w-5"
        alt="Arrow icon"
      />
      <span className="blink-text">TRADING LIVE NOW</span>
    </button>

    {showPopup("sol") && (
      <div
        className="absolute bottom-[110%] left-1/2 -translate-x-1/2 flex gap-2 bg-white rounded-full p-2 shadow-lg border border-gray-200 z-50"
        onClick={(e) => e.stopPropagation()}
      >
        <a
          href="https://pump.fun/7xAinob3Fmi6Sf1zA1kUDkuSuBh4KEVtuKqL6WM1DWKr"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-r from-pink-400 to-purple-500 hover:scale-110 transition"
        >
          <img src="logo.webp" alt="Pump.fun" className="w-6 h-6" />
        </a>
        <a
          href="https://dexscreener.com/solana/7xainob3fmi6sf1za1kudkusubh4kevtukql6wm1dwkr"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-r from-blue-400 to-cyan-500 hover:scale-110 transition"
        >
          <img src="/dex.png" alt="Dex" className="w-5 h-5" />
        </a>
      </div>
    )}
  </div>

  {/* Check Info */}
  <a
    href="https://babysol.vercel.app/"
    className="order-3 sm:order-3 flex justify-center items-center gap-2 h-[60px] sm:h-[64px] rounded-full font-semibold text-white border-2 border-white 
      bg-[linear-gradient(90deg,#6BC9FF_0%,#AA81FF_47.12%,#FF6EB3_100%)] 
      shadow-[0px_4px_16px_#6BC9FF] transition-transform w-full sm:w-[220px] sm:hover:scale-105 text-lg"
  >
    <FiGlobe className="text-xl sm:text-2xl" /> 
  <span>Sol Website</span>
  </a>

{/* Check Info */}


</div>


<style jsx>{`
  .blink-text {
    color: #ff4d4d;
    font-weight: bold;
    animation: blink 1s infinite;
  }
  @keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0; }
    100% { opacity: 1; }
  }
`}</style>

      </div>
    </div>
  );
}
